<template>
  <div class="m">
    <div
      :class="`bubble ${
        $store.state.user.chat.id == message.chat_id ? 'me' : ''
      }`"
    >
      <span v-if="$store.state.user.chat.id == message.chat_id" class="name"
        >{{ "you" | setText("Вы") }}
      </span>
      <span v-else class="name">
        <span v-if="message.chat && message.chat.userable">{{
          message.chat.userable.full_name
        }}</span>
      </span>
      <div class="files" v-if="message.media && message.media.length">
        <div v-for="media in message.media" :key="media.id">
          <a :href="media.links.original" target="_blank">
            {{ media.file_name }}
          </a>
        </div>
      </div>
      <span class="text"> {{ message.message }} </span>
      <span class="date"> {{ message.created_at | dateTimeFormat }} </span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      default: null,
    },
  },
  computed: {},
  components: {},
  methods: {},
  created() {},
  data() {
    return {};
  },
};
</script>
<style lang="scss">
</style>
